module.exports = __webpack_public_path__ + "img/jonathan-pro.15227eb6.jpg";